import {
  ChakraProvider,
  Box,
  theme,
} from "@chakra-ui/react"
import QuestionMenu from "./components/common/QuestionMenu"
import Footer from "./components/footer/Footer"
import DealsSection from "./components/home/deals-section/DealsSection"
import LandingSection from "./components/home/landing-section/LandingSection"
import NavigationBar from "./components/navigation/NavigationBar"

export const App = () => (
  <ChakraProvider theme={theme}>
    <Box bg="rgba(245, 245, 245, 1)" color="rgb(0 0 0 / 85%)" minH="100vh">
      <NavigationBar />
      <QuestionMenu />
      <LandingSection />
      <DealsSection />
      <Footer />
    </Box>
  </ChakraProvider>
)
